import { ApiRequest } from "@plinknz/tah-website-elements";

export const whataRequest = new ApiRequest({
  loginPath: "/",
  baseUrl: process.env.WHATA_URL,
  useCache: false,
  useContentType: true,
});
